var _style, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMccMail = function SvgMccMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".MCC-Mail_svg__st0{fill-rule:evenodd;clip-rule:evenodd}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 29V13.287c0-1.04 1.196-1.625 2.017-.987l14.914 12.645a5 5 0 0 0 6.138 0L37.983 12.3c.82-.638 2.017-.053 2.017.987V29a5 5 0 0 1-5 5H5a5 5 0 0 1-5-5Z",
    className: "MCC-Mail_svg__st0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.547 19.473 2.472 6.3c-.909-.745-.417-2.3.727-2.3H36.8c1.144 0 1.636 1.555.727 2.3L21.453 19.473a2.267 2.267 0 0 1-2.906 0Z",
    className: "MCC-Mail_svg__st0"
  })));
};
export default SvgMccMail;